<template>
	<spinner v-if="!errorCode" />
	<error-card v-else :app-info="appInfo" :code="errorCode" :title="errorTitle">
		<template v-if="appInfo.app_name === 'device-agent'" #logo>
			<img src="/images/hp-device-agent-logo.svg" alt="HP" />
		</template>
		<template v-else-if="appInfo.app_name === 'brand-centre'" #logo>
			<img src="/images/hp-brand-centre-logo.svg" alt="HP" />
		</template>
		<template v-else-if="appInfo.app_name === 'control-centre'" #logo>
			<img src="/images/hp-control-centre-logo.svg" alt="HP" />
		</template>
		<template v-else-if="appInfo.app_name === 'workforce'" #logo>
			<img src="/images/hp-workforce-logo.svg" alt="HP" />
		</template>
		<template v-else-if="appInfo.app_name === 'sfl'" #logo>
			<img src="/images/hp-sfl-logo.svg" alt="HP" />
		</template>
		<template v-else-if="appInfo.app_name === 'sf'" #logo>
			<img src="/images/hp-sf-logo.svg" alt="HP" />
		</template>
	</error-card>
</template>

<script type="text/javascript">
import axios from 'axios';
import Spinner from '@/components/Spinner';
import ErrorCard from '@/components/ErrorCard';
export default {
	name: 'LogoutPage',
	components: {
		Spinner,
		ErrorCard
	},
	data() {
		const { authBase, apps, app } = window.$config;
		return {
			logoutRedirectUrl: `${window.location.origin}/logout`,
			loginPageBase: '',
			errorCode: 0,
			authBase,
			apps,
			app
		};
	},
	computed: {
		appInfo() {
			// OneUID does not support query params in the logout URL, so we have set the app name as a URL param
			// after redirecting back from the SSO logout page
			let app_name = this.$route.params.name;
			if (!app_name) {
				app_name = this.$route.query.app_name;
			}
			const { standard_login = 0, auth_error, port = 54322, state } = this.$route.query || {};
			let stateFromUrl = {};
			try {
				stateFromUrl = JSON.parse(atob(state));
			} catch (e) {
				stateFromUrl = {};
			}
			const appInfo = { app_name, standard_login, auth_error, port, ...stateFromUrl };
			Object.assign(appInfo, this.apps[appInfo.app_name], this.app);
			return appInfo;
		},
		errorTitle() {
			return this.errorCode === 1004 ? 'Sign in failed' : 'Sign out failed';
		},
		isHPID() {
			return this.appInfo.sso === 'hpid';
		},
		hpEndpoint() {
			if (this.isHPID) {
				return `${this.loginPageBase}/logout`;
			} else {
				return `${this.loginPageBase}/idp/startSLO.ping`;
			}
		}
	},
	async created() {
		const { state } = this.$route.query || {};
		await this.getClientConfig();
		if (this.errorCode) return;
		// after coming back from the SSO logout page, if state is present, it means we have been redirected from HPID
		// and otherwise, we have been redirected from OneUID if app_name is present as URL param, and it's a OneUID client
		const hasRedirectedFromSSO = state || (this.$route.params.name && !this.isHPID);
		if (hasRedirectedFromSSO) {
			if (this.appInfo.auth_error) {
				this.errorCode = 1004;
			} else {
				window.location.href = this.appInfo.redirectUrl;
			}
		} else if (this.appInfo.appName) {
			let queryParams = '';
			if (this.isHPID) {
				// for HPID logout we can set state as a query param
				const state = { app_name: this.appInfo.app_name };
				if (state.app_name === 'device-agent') Object.assign(state, { port: this.appInfo.port });
				if (this.appInfo.standard_login) Object.assign(state, { standard_login: this.appInfo.standard_login });
				if (this.appInfo.auth_error) Object.assign(state, { auth_error: this.appInfo.auth_error });
				const encodedState = btoa(JSON.stringify(state));
				queryParams = `post_logout_redirect_uri=${encodeURIComponent(this.logoutRedirectUrl)}&state=${encodedState}`;
			} else {
				// OneUID does not support query params in the logout URL, so we need to set the app name as a URL param
				queryParams = `TargetResource=${this.logoutRedirectUrl}/${this.appInfo.app_name}`;
			}
			window.location.href = `${this.hpEndpoint}?${queryParams}`;
		} else {
			this.errorCode = 1001;
		}
	},
	methods: {
		async getClientConfig() {
			try {
				if (!this.appInfo.app_name || !this.appInfo.appName) throw new Error();
				const { data: clientConfig } = await axios.get(`${this.authBase}/sso/client/${this.appInfo.app_name}`);
				if (!clientConfig || !clientConfig.clientId) throw new Error();

				this.loginPageBase = clientConfig.loginPageUrl;
				this.appInfo.clientId = clientConfig.clientId;
				this.appInfo.sso = clientConfig.sso;

				// Set the redirectUrl based on the client config. The url of the device agent needs to have included the port,
				// and the url of the sf needs to have included the standard_login
				this.appInfo.redirectUrl =
					location.hostname === 'localhost' ? 'http://localhost:8080/#/login' : `${clientConfig.redirectUrl}login`;
				if (this.appInfo.app_name === 'device-agent') {
					this.appInfo.redirectUrl = `${clientConfig.redirectUrl}:${this.appInfo.port}/#/login`;
				} else if (this.appInfo.app_name === 'sf') {
					this.appInfo.redirectUrl = `${this.appInfo.redirectUrl}?standard_login=${this.appInfo.standard_login}`;
				}
			} catch (err) {
				this.errorCode = 1001;
			}
		}
	}
};
</script>

<style lang="scss">
img {
	height: 40px !important;
}
.LogoutPage {
	height: 100vh;
	width: 100vw;

	> .row.justify-content-center {
		height: 100%;
		> .col-sm-6.col-lg-4 {
			align-self: center;
		}
	}
}
</style>
